import sdkInstanceProvider from "@src/client/sdk/sdkInstanceProvider.js";
import {
  getKeyedCookieValue,
  setKeyedCookieValue
} from "@src/client/context/cookies";
import { fetchDefaultDeliveryCountry } from "@src/api";
import {
  RSFT_WELCOME_MESSAGE_COOKIE_NAME,
  RSFT_RESOLVED_DELIVERY_COUNTRY_KEY
} from "@template/constants";

export const getResolvedDeliveryCountry = async ({ geoCountry }) => {
  const resolvedDeliveryCountry = getKeyedCookieValue(
    RSFT_WELCOME_MESSAGE_COOKIE_NAME,
    RSFT_RESOLVED_DELIVERY_COUNTRY_KEY
  );

  if (resolvedDeliveryCountry) {
    return resolvedDeliveryCountry;
  }

  const {
    customer: { profile }
  } = await sdkInstanceProvider("identity");

  let customerId;
  try {
    ({ customerId } = await profile());
    // eslint-disable-next-line no-empty
  } catch (error) {}

  if (!customerId) {
    setKeyedCookieValue(
      RSFT_WELCOME_MESSAGE_COOKIE_NAME,
      RSFT_RESOLVED_DELIVERY_COUNTRY_KEY,
      geoCountry
    );

    return geoCountry;
  }

  let deliveryCountry;

  try {
    ({ deliveryCountry } = await fetchDefaultDeliveryCountry(customerId));
  } catch (_) {
    setKeyedCookieValue(
      RSFT_WELCOME_MESSAGE_COOKIE_NAME,
      RSFT_RESOLVED_DELIVERY_COUNTRY_KEY,
      geoCountry
    );

    return geoCountry;
  }

  setKeyedCookieValue(
    RSFT_WELCOME_MESSAGE_COOKIE_NAME,
    RSFT_RESOLVED_DELIVERY_COUNTRY_KEY,
    deliveryCountry
  );

  return deliveryCountry;
};
